import type { WizardOpenConfig } from './ltl.types';

// Wizard open/close — bridges the page ↔ drawer mount/unmount
export const LTL_OPEN_WIZARD = 'LTL_OPEN_WIZARD';
export const openLtlWizard = (config: WizardOpenConfig = { mode: 'new-quote' }) => ({
  type: LTL_OPEN_WIZARD,
  config,
});

export const LTL_CLOSE_WIZARD = 'LTL_CLOSE_WIZARD';
export const closeLtlWizard = () => ({
  type: LTL_CLOSE_WIZARD,
});

// Cancel Shipment (grid-level operation)
export const LTL_CANCEL_SHIPMENT_REQUEST = 'LTL_CANCEL_SHIPMENT_REQUEST';
export const cancelShipmentRequest = (freightShipmentIds: number[]) => ({
  type: LTL_CANCEL_SHIPMENT_REQUEST,
  freightShipmentIds,
});

export const LTL_CANCEL_SHIPMENT_SUCCESS = 'LTL_CANCEL_SHIPMENT_SUCCESS';
export const cancelShipmentSuccess = () => ({
  type: LTL_CANCEL_SHIPMENT_SUCCESS,
});

export const LTL_CANCEL_SHIPMENT_ERROR = 'LTL_CANCEL_SHIPMENT_ERROR';
export const cancelShipmentError = (error: string) => ({
  type: LTL_CANCEL_SHIPMENT_ERROR,
  error,
});

// Document download (grid-level operation)
export const LTL_DOWNLOAD_DOCUMENT_REQUEST = 'LTL_DOWNLOAD_DOCUMENT_REQUEST';
export const downloadDocumentRequest = (productTransactionId: string, documentType: string) => ({
  type: LTL_DOWNLOAD_DOCUMENT_REQUEST,
  productTransactionId,
  documentType,
});

export const LTL_DOWNLOAD_DOCUMENT_SUCCESS = 'LTL_DOWNLOAD_DOCUMENT_SUCCESS';
export const downloadDocumentSuccess = (document: unknown) => ({
  type: LTL_DOWNLOAD_DOCUMENT_SUCCESS,
  document,
});

export const LTL_DOWNLOAD_DOCUMENT_ERROR = 'LTL_DOWNLOAD_DOCUMENT_ERROR';
export const downloadDocumentError = (error: string) => ({
  type: LTL_DOWNLOAD_DOCUMENT_ERROR,
  error,
});

// Track Shipment (grid-level operation)
export const LTL_TRACK_SHIPMENT_REQUEST = 'LTL_TRACK_SHIPMENT_REQUEST';
export const trackShipmentRequest = (trackingNumber: string, trackingType: string, scac?: string) => ({
  type: LTL_TRACK_SHIPMENT_REQUEST,
  trackingNumber,
  trackingType,
  scac,
});

export const LTL_TRACK_SHIPMENT_SUCCESS = 'LTL_TRACK_SHIPMENT_SUCCESS';
export const trackShipmentSuccess = (trackingInfo: unknown) => ({
  type: LTL_TRACK_SHIPMENT_SUCCESS,
  trackingInfo,
});

export const LTL_TRACK_SHIPMENT_ERROR = 'LTL_TRACK_SHIPMENT_ERROR';
export const trackShipmentError = (error: string) => ({
  type: LTL_TRACK_SHIPMENT_ERROR,
  error,
});

// Pusher-driven freight quote actions
export const LTL_FREIGHT_QUOTE_PUSHER_SUCCESS = 'LTL_FREIGHT_QUOTE_PUSHER_SUCCESS';
export const freightQuoteSuccess = (messageGuid: string, data: unknown) => ({
  type: LTL_FREIGHT_QUOTE_PUSHER_SUCCESS,
  messageGuid,
  data,
});

export const LTL_FREIGHT_QUOTE_PUSHER_ERROR = 'LTL_FREIGHT_QUOTE_PUSHER_ERROR';
export const freightQuoteError = (messageGuid: string, errorMessage: string) => ({
  type: LTL_FREIGHT_QUOTE_PUSHER_ERROR,
  messageGuid,
  errorMessage,
});

// Pusher-driven freight book actions
export const LTL_FREIGHT_BOOK_PUSHER_SUCCESS = 'LTL_FREIGHT_BOOK_PUSHER_SUCCESS';
export const freightBookSuccess = (messageGuid: string, data: unknown) => ({
  type: LTL_FREIGHT_BOOK_PUSHER_SUCCESS,
  messageGuid,
  data,
});

export const LTL_FREIGHT_BOOK_PUSHER_ERROR = 'LTL_FREIGHT_BOOK_PUSHER_ERROR';
export const freightBookError = (messageGuid: string, errorMessage: string) => ({
  type: LTL_FREIGHT_BOOK_PUSHER_ERROR,
  messageGuid,
  errorMessage,
});

// Re-export grid actions for backward compatibility
export { GET_FREIGHT_GRID_REQUEST, getFreightGridRequest } from './grid/ltl.grid.actions';
